import { queryParams, type RouteQueryOptions, type RouteDefinition } from './../../../../../wayfinder'
/**
* @see \App\Http\Controllers\Role\CreateRoleController::__invoke
* @see app/Http/Controllers/Role/CreateRoleController.php
* @route '/api/role'
*/
const CreateRoleController = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: CreateRoleController.url(options),
    method: 'post',
})

CreateRoleController.definition = {
    methods: ["post"],
    url: '/api/role',
} satisfies RouteDefinition<["post"]>

/**
* @see \App\Http\Controllers\Role\CreateRoleController::__invoke
* @see app/Http/Controllers/Role/CreateRoleController.php
* @route '/api/role'
*/
CreateRoleController.url = (options?: RouteQueryOptions) => {
    return CreateRoleController.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\Role\CreateRoleController::__invoke
* @see app/Http/Controllers/Role/CreateRoleController.php
* @route '/api/role'
*/
CreateRoleController.post = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: CreateRoleController.url(options),
    method: 'post',
})

export default CreateRoleController